<template>
	<div id="sfjl" v-loading="loading">
		<div class="sfjl_main">
			<div class="query_info">
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					placeholder="请选择开始日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					placeholder="请选择结束日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<!-- 选择游戏 -->
				<el-select v-model="currChooseGame" placeholder="请选择游戏">
					<el-option v-for="item in game" :key="item.GameId" :label="item.CN_Name" :value="item.GameId" />
				</el-select>
				<el-button class="el-button--primary" @click="tzCxBtn">查询</el-button>
			</div>
			<!-- 彩票的表格 -->
			<div class="czTable">
				<!-- 彩票表格 -->
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="PlatName" label="平台名称" />
					<el-table-column prop="GameName" label="游戏名称" />
					<el-table-column prop="BetMoney" label="投注金额" />
					<el-table-column prop="WinMoney" label="中奖金额" />
					<el-table-column prop="GameTime" label="游戏时间" width="185" />
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.webp" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>
				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import { timeFormatProcessing } from "../../util/common";

export default {
	data() {
		return {
			loading: false,
			cancelOrderTips: "",
			currOrderType: "",
			//游戏类型
			game: [],
			currChooseGame: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			//详情数据
			detailData: null,
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},
	mounted() {
		this.initDate();
		this.getGameType();
		this.tzCxBtn();
	},
	methods: {
		initDate() {
			this.beginDate = `${timeFormatProcessing()} 03:00:00`;
			this.endDate = `${timeFormatProcessing(0, 1)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.tzCxBtn();
		},
		//查询按钮
		tzCxBtn() {
			let that = this;
			let url = "/api/OrderReport/GetUserThirdGameRecord";
			let tzData = {
				StartTime: this.beginDate,
				EndTime: this.endDate,
				GameType: this.currChooseGame,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
			};
			this.loading = true;
			postAjax(url, tzData)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		//得到所有游戏类型
		getGameType() {
			let that = this;
			let url = "/api/ThirdGame/GetGames";
			postAjax(url).then(function (data) {
				let tempArry = [{ CN_Name: "全部", GameId: "" }];
				if (data.IsSucess) {
					tempArry.push(...data.Data);
					that.game = tempArry;
				}
			});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.tzCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			return row[column.property];
		},
	},

	//过滤器
	filters: {},
};
</script>
<style type="scss">
#sfjl .sfjl_main {
	padding: 20px 0px 20px 0;
}

#sfjl .detail_style {
	color: #d86556;
}

.detail_style:hover {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderReport/sfjl.vue